import cleanedFilename from '~/util/cleanedFilename';

export default {
  ADD_BUTTON: `${cleanedFilename(__filename)}-add-button`,
};
